/** 消息连接只属于当前登录身份；换号、维护和卸载立即停止旧连接与重连。 */
export function createSessionSocket(options:{identity:()=>string;url:()=>string;connect:(url:string)=>WebSocket;message:(event:MessageEvent)=>void;changed:(socket:WebSocket|null)=>void;schedule?:(fn:()=>void,delay:number)=>any;cancel?:(id:any)=>void}){
  let identity='',generation=0,socket:WebSocket|null=null,timer:any,disposed=false
  const schedule=options.schedule || setTimeout,cancel=options.cancel || clearTimeout
  const close=()=>{generation++;if(timer!==undefined)cancel(timer);timer=undefined;const previous=socket;socket=null;options.changed(null);previous?.close()}
  const connect=()=>{
    if(disposed || !identity || identity!==options.identity())return
    const run=++generation,current=options.connect(options.url());socket=current;options.changed(current)
    const active=()=>!disposed && run===generation && socket===current && identity===options.identity()
    current.addEventListener('message',event=>{if(active())options.message(event as MessageEvent)})
    current.addEventListener('close',()=>{if(!active())return;socket=null;options.changed(null);timer=schedule(()=>{timer=undefined;if(run===generation)connect()},5000)})
    current.addEventListener('error',()=>{/* 由close事件安排有限身份范围内的重连。 */})
  }
  return {
    refresh(){const next=options.identity();if(disposed || next===identity)return;close();identity=next;if(identity)connect()},
    dispose(){disposed=true;identity='';close()}
  }
}
